module.exports = __webpack_public_path__ + "static/img/15.387a53d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/15.jpg
// module id = ojHh
// module chunks = 0